import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { CATALOG_PRODUCTS_TYPE, PRODUCTS_ORDER_KEY } from '@/helpers';
import { globalLoader, pluralizate } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'CatalogType',
  mixins: [dynamicHead],
  components: {
    BreadcrumbsSimple,
    ProductsBlock,
    Pagination
  },
  data() {
    return {
      PRODUCTS_ORDER_KEY,
      catalogType: CATALOG_PRODUCTS_TYPE.BESTSELLERS,
      catalogTypeData: null,
      sortFilterType: CATALOG_PRODUCTS_TYPE.BESTSELLERS,
      catalogTypeProducts: [],
      catalogTypeMeta: null,
      isCatalogTypeLoading: false
    };
  },
  created() {
    let { name } = this.$route;
    if (name.indexOf(CATALOG_PRODUCTS_TYPE.NEWEST) > -1) {
      this.catalogType = CATALOG_PRODUCTS_TYPE.NEWEST;
    }
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList'
    }),
    pageKey() {
      return this.catalogType === CATALOG_PRODUCTS_TYPE.NEWEST ? 'novinki' : 'top-prodazh';
    },
    breadcrumbs() {
      return [{ title: this.$t('catalog'), route: { name: 'products' } }];
    },
    titlePluralizate() {
      return pluralizate(
        this.catalogTagMeta ? this.catalogTagMeta.total : 0,
        this.$t('label.products.countOne'),
        this.$t('label.products.countSimple'),
        this.$t('label.products.countMany')
      );
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.catalogTypeProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.catalogTypeProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getCatalogProducts: 'catalog/GET_CATALOG_PRODUCTS',
      getPage: 'staticPages/GET_PAGE'
    }),
    _getProducts() {
      this.isCatalogTypeLoading = true;
      let { params: routeParams, query } = this.$route;
      let { page } = routeParams;
      let { orderby } = query;

      this.sortFilterType = orderby
        ? orderby
        : this.catalogType === CATALOG_PRODUCTS_TYPE.NEWEST
          ? PRODUCTS_ORDER_KEY.NEWEST
          : PRODUCTS_ORDER_KEY.BESTSELLERS;

      return this.getCatalogProducts({
        page: page ? Number(page) : 1,
        sort_filter_type: this.sortFilterType
      })
        .then((result) => {
          this.catalogTypeProducts = result.data;
          this.catalogTypeMeta = result.meta;
        })
        .finally(() => {
          this.isCatalogTypeLoading = false;
        });
    },
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];
      promiseCollection.push(this._getProducts());
      promiseCollection.push(
        this.getPage(this.pageKey).then((data) => {
          this.catalogTypeData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection);
      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.catalogTypeData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
